if (!window.ByteWishlistIcYastik && window.location.pathname.includes('/apps/wishlistapp')) {
  const LINE_SELECTOR = '.byte-wishlist-line';
  const LINK_SELECTOR = 'a.product-image-link, a[href*="/products/"]';
  const PRICE_SELECTOR = '.product-price';
  const STATE_ATTR = 'data-ic-yastik-state';
  const VIEW = 'wishlist-ic-yastik';

  const cache = new Map();

  const getHandle = (line) => {
    const href = line.querySelector(LINK_SELECTOR)?.getAttribute('href') || '';
    const match = href.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : null;
  };

  // Returns { icYastik, prices, product }: the "*iç yastık dahil" price markup (null when the product
  // has no such variant), a variant id → theme-formatted price map and the product's options/variants
  // (null when unavailable).
  const fetchProductData = (handle) => {
    if (cache.has(handle)) return cache.get(handle);

    const root = window.Shopify?.routes?.root || '/';
    const request = fetch(`${root}products/${encodeURIComponent(handle)}?view=${VIEW}`)
      .then((response) => (response.ok ? response.text() : ''))
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        let prices = {};
        let product = null;
        try {
          prices = JSON.parse(doc.querySelector('[data-variant-prices]')?.textContent || '{}');
        } catch (error) {}
        try {
          product = JSON.parse(doc.querySelector('[data-product-json]')?.textContent || 'null');
        } catch (error) {}
        return {
          icYastik: doc.querySelector('.price-item--ic-yastik')?.outerHTML || null,
          prices,
          product,
        };
      })
      .catch(() => ({ icYastik: null, prices: {}, product: null }));

    cache.set(handle, request);
    return request;
  };

  const processLine = async (line) => {
    if (line.hasAttribute(STATE_ATTR)) return;
    line.setAttribute(STATE_ATTR, 'pending');

    const handle = getHandle(line);
    const { icYastik: markup, prices } = handle ? await fetchProductData(handle) : { icYastik: null, prices: {} };
    if (!line.isConnected) return;

    // Replace the app's "TRY 2130.30" with the theme's money format.
    const formattedPrice = prices[line.dataset.variantId];
    const priceElement = line.querySelector(PRICE_SELECTOR);
    if (formattedPrice && priceElement) priceElement.textContent = formattedPrice;

    if (!markup) {
      line.setAttribute(STATE_ATTR, 'none');
      return;
    }

    const wrapper = document.createElement('div');
    wrapper.className = 'price--ic-yastik-text byte-wishlist-ic-yastik';
    wrapper.innerHTML = markup;

    const price = line.querySelector(PRICE_SELECTOR);
    if (price) {
      price.insertAdjacentElement('afterend', wrapper);
    } else {
      (line.querySelector('.product-info') || line).appendChild(wrapper);
    }
    line.setAttribute(STATE_ATTR, 'done');
  };

  const processAll = () => {
    document.querySelectorAll(`${LINE_SELECTOR}:not([${STATE_ATTR}])`).forEach(processLine);
  };

  let scheduled = false;
  const scheduleProcess = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      processAll();
    });
  };

  const init = () => {
    processAll();
    // The app renders/re-renders the list client-side, so watch for new lines.
    new MutationObserver(scheduleProcess).observe(document.body, { childList: true, subtree: true });
  };

  window.ByteWishlistIcYastik = { refresh: processAll, getHandle, fetchProductData };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
}
